export enum ExpirienceLevelEnum {
    ROOKIE = 1,
    ADVANCED = 2,
    EXPERT = 3
}

export const LEVELS_FOR_ADVANCED_SERVICES = [ExpirienceLevelEnum.ADVANCED, ExpirienceLevelEnum.EXPERT];

export const LEVELS_FOR_EXPERT_SERVICES = [ExpirienceLevelEnum.EXPERT];

export const LEVELS_FOR_ROOKIE_SERVICES = [ExpirienceLevelEnum.ROOKIE, ExpirienceLevelEnum.ADVANCED, ExpirienceLevelEnum.EXPERT];


export const ExpirienceLevelNomenclatureMap: Map<ExpirienceLevelEnum, string> = new Map([
    [ExpirienceLevelEnum.ROOKIE, 'Младши'],
    [ExpirienceLevelEnum.ADVANCED, 'Старши'],
    [ExpirienceLevelEnum.EXPERT, 'Експерт'],
]);